import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ApiService } from 'src/app/service/api.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { FileAlertComponent } from '../alerts/file-alert/file-alert.component';
import { SelectStockGEDCOMComponent } from '../modal/select-stock-gedcom/select-stock-gedcom.component';

@Component({
  selector: 'app-gedcom-upload',
  templateUrl: './gedcom-upload.component.html',
  styleUrls: ['./gedcom-upload.component.scss']
})
export class GedcomUploadComponent implements OnInit {

  @Output() gedcomEvent = new EventEmitter<any>();

  gedcom: any = []
  officialGedcom: any = []
  gedcomLength
  displayedColumns: string[] = ['filename', 'uploaded', 'individuals', 'size', 'delete'];
  fileName: string = null;
  fileToUpload: File | null = null;
  fileInputName: string = null;
  userFilename = new UntypedFormControl('', Validators.required)
  showLoader: boolean = true;

  testArray: any = []

  constructor(private apiService: ApiService, private auth: AuthService, private MatDialog: MatDialog, private profileService: ProfileService) { }



  openStockSelector() { // Move to seperate service and remove from gedcom.components.ts
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "select-stockGEDCOM";
    dialogConfig.data = this.gedcom;
    const modalDialog = this.MatDialog.open(SelectStockGEDCOMComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((result) => {
      this.getGedcomFiles();
      this.gedcomEvent.emit("stockGEDCOM")
    })
  }

  formatBytes(bytes, decimals = 2) { // Move to seperate service and remove from gedcom.components.ts
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  getGedcomFiles() { // Move to seperate service and remove from gedcom.components.ts
    this.gedcom = []
    this.apiService.getGedcoms().then((gedcoms: any) => {
      gedcoms.forEach(gedcom => {
        this.gedcom.push({ filename: gedcom.filename.split('-')[1], indis: gedcom.indis || 0, size: this.formatBytes(gedcom.size), uploaded: gedcom.uploaded, id: gedcom._id, publicGedcom: gedcom.publicGedcom })
      });

      this.gedcom.sort((a: any, b: any) => {
        return <any>new Date(b.uploaded) - <any>new Date(a.uploaded);
      });
      this.showLoader = false;
    }, err => { console.log('error', err) })
  }

  handleFileInput(files: FileList) {
    let warningData = []
    let splitFileName = files.item(0).name.split(".")
    if (splitFileName[splitFileName.length - 1] == 'ged') {
      this.fileToUpload = files.item(0);
      this.fileInputName = this.fileToUpload.name
    }
    else {
      this.fileInputName = ''
      const dialogConfig = new MatDialogConfig();
      // The user can't close the dialog by clicking outside its body
      dialogConfig.disableClose = false;
      dialogConfig.id = "FileAlertComponent-component";
      const modalDialog = this.MatDialog.open(FileAlertComponent, dialogConfig);
    }
  }

  uploadFile() {
    this.showLoader = true

    this.apiService.postFile(this.fileToUpload, this.userFilename.value).then((doc_id) => { // doc_id = MongoDB document ID
      this.getGedcomFiles()
      this.fileInputName = null;
      this.fileToUpload = null;
      this.userFilename.patchValue(null);
      this.fileName = null;
      this.showLoader = false
      this.gedcomEvent.emit(doc_id)
    }, err => console.log(err))
  }

  ngOnInit(): void {
  }

}
